import { type SerializedError } from '@databases/types';

export enum AsyncOperationStatus {
  INITIAL = 'initial',
  PENDING = 'pending',
  SUCCEEDED = 'succeeded',
  ERROR = 'error',
}

export type AsyncOperation<T> =
  | { status: AsyncOperationStatus.INITIAL | AsyncOperationStatus.PENDING }
  | (T extends void
      ? { status: AsyncOperationStatus.SUCCEEDED }
      : { status: AsyncOperationStatus.SUCCEEDED; data: T })
  | { status: AsyncOperationStatus.ERROR; error: SerializedError };
